export default __webpack_public_path__ + "static/media/sample-device-large.eb54d16a.svg";